// extracted by mini-css-extract-plugin
module.exports = {"schedule":"schedules-module--schedule--1miNo","impossibleSchedule":"schedules-module--impossibleSchedule--mV2we","class":"schedules-module--class--2Q5Pi"};